

exports.__esModule = true;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;

function formatReturnContent($renderContent, merchantName) {
    if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
        return $renderContent('common.returnToMerchant', { merchantName: merchantName });
    }

    return $renderContent('common.returnToDefaultMerchant');
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-return-to-merchant/dist/formatReturnContent.js
// module id = ../node_modules/xo-return-to-merchant/dist/formatReturnContent.js
// module chunks = 0